import styled from "styled-components";
import { ContentContainer } from "./ContentContainer";

export const CalculationOutput = ({title, prefix, value, sufix, error, warning}) => {
    return (
        <StyledCalculationOutput
            className={ error ? 'error' : warning ? 'warning' : null}
            padding="lg" contentGap="md"
        >
            <div className="outputHeader">
                <div className="outputTitle" lang="nb">
                    {title}
                </div>
                <div className="outputAbbreviation">
                    {prefix}
                </div>
            </div>
            <div className="outputContent">
                <div className="value">{value}</div>
                <div className="sufix">{sufix}</div>
            </div>
        </StyledCalculationOutput>
    )
}

const StyledCalculationOutput = styled(ContentContainer)`

    &.error
    {
        border: 1px solid ${({theme}) => theme.colors.errorForeground};
        background: rgba(${({theme}) => theme.colors.errorForegroundRGB}, 0.25);
    }

    &.warning
    {
        border: 1px solid ${({theme}) => theme.colors.warningForeground};
        background: rgba(${({theme}) => theme.colors.warningBackgroundRGB}, 0.25);
    }

    div.outputHeader
    {
        display: flex;
        //flex-wrap: wrap;
        justify-content: space-between;
        align-items: baseline;
        gap: ${({theme}) => theme.spacing.md} ${({theme}) => theme.spacing.lg};

        div.outputTitle
        {
            font-weight: 400;
            overflow-wrap: anywhere;
            hyphens: auto;
        }

        div.outputAbbreviation
        {
            font-size: ${({theme}) => theme.fontSize.sm};
            padding: ${({theme}) => theme.spacing.xs} ${({theme}) => theme.spacing.md};
            border-radius: ${({theme}) => theme.cornerRadius.sm};
            color: ${({theme}) => theme.colors.mutedForeground};
            font-weight: 600;
            background: ${({theme}) => theme.colors.neutralPrimaryBorder};
        }
    }

    div.outputContent
    {
        display: flex;
        align-items: baseline;
        gap: ${({theme}) => theme.spacing.sm};

        div.value
        {
            font-weight: 600;
            font-size: ${({theme}) => theme.fontSize.xl};
        }

        div.sufix
        {
            color: ${({theme}) => theme.colors.mutedForeground};
        }
        
    }
`